let initialized = false;

export function initTeamModal() {
  if (initialized) return;

  const modal = document.querySelector(".team__modal--main");
  const cards = document.querySelectorAll(".team__card-main");

  if (!modal || cards.length === 0) return;

  initialized = true;

  cards.forEach(function(card) {
    const openCard = function(event) {
      event.preventDefault();
      populateModal(modal, card);
      openModal(modal);
    };

    if (!card.hasAttribute("tabindex")) {
      card.setAttribute("tabindex", "0");
    }

    if (!card.hasAttribute("role")) {
      card.setAttribute("role", "button");
    }

    card.addEventListener("click", openCard);
    card.addEventListener("keydown", function(event) {
      if (event.key === "Enter" || event.key === " ") {
        openCard(event);
      }
    });
  });

  modal.querySelectorAll(".team__modal-close").forEach(function(closeButton) {
    closeButton.addEventListener("click", function(event) {
      event.preventDefault();
      closeModal(modal);
    });
  });

  document.addEventListener("keydown", function(event) {
    if (event.key === "Escape" && modal.classList.contains("open")) {
      closeModal(modal);
    }
  });
}

function populateModal(modal, card) {
  setText(modal, ".team__content-name", getText(card, ".member-name"));
  setText(modal, ".team__content-title", getText(card, ".member-item-job"));
  setHtml(
    modal,
    ".team__content-rich",
    getHtml(card, ".team__card-content-rich")
  );
  setContactLink(
    modal,
    ".team__content-phone",
    card.querySelector(".team__card-content-phone")
  );
  setContactLink(
    modal,
    ".team__content-email",
    card.querySelector(".team__card-content-email")
  );
  setContactLink(
    modal,
    ".team__content-linkedin",
    card.querySelector(".team__card-content-linkedin")
  );
  setImage(modal, card.querySelector(".team__card-overlay-img"));
}

function openModal(modal) {
  modal.classList.add("open");
  modal.setAttribute("aria-hidden", "false");
}

function closeModal(modal) {
  modal.classList.remove("open");
  modal.setAttribute("aria-hidden", "true");
}

function getText(parent, selector) {
  const element = parent.querySelector(selector);
  return element ? element.textContent.trim() : "";
}

function getHtml(parent, selector) {
  const element = parent.querySelector(selector);
  return element ? element.innerHTML : "";
}

function setText(parent, selector, value) {
  const element = parent.querySelector(selector);

  if (!element) return;

  element.textContent = value;
  element.style.display = value ? "" : "none";
}

function setHtml(parent, selector, value) {
  const element = parent.querySelector(selector);

  if (!element) return;

  element.innerHTML = value;
  element.style.display = value ? "" : "none";
}

function setContactLink(modal, selector, sourceLink) {
  let modalLink = modal.querySelector(selector);

  if (!modalLink) {
    const contacts = modal.querySelector(".team__content-contact");

    if (!contacts) return;

    modalLink = document.createElement("div");
    modalLink.className = "contact__link " + selector.slice(1);
    contacts.appendChild(modalLink);
  }

  const href = sourceLink ? sourceLink.getAttribute("href") : "";
  const label = sourceLink ? sourceLink.textContent.trim() : "";
  const isPlaceholder = !href || href === "#" || label.toLowerCase() === "text link";

  const tagName = isPlaceholder ? "DIV" : "A";

  if (modalLink.tagName !== tagName) {
    const replacement = document.createElement(tagName.toLowerCase());

    Array.prototype.forEach.call(modalLink.attributes, function(attribute) {
      if (attribute.name !== "href") {
        replacement.setAttribute(attribute.name, attribute.value);
      }
    });

    while (modalLink.firstChild) {
      replacement.appendChild(modalLink.firstChild);
    }

    modalLink.parentNode.replaceChild(replacement, modalLink);
    modalLink = replacement;
  }

  modalLink.style.display = isPlaceholder ? "none" : "";

  if (isPlaceholder) {
    modalLink.removeAttribute("href");
    return;
  }

  modalLink.setAttribute("href", href);
  setLinkLabel(modalLink, label);
}

function setLinkLabel(link, label) {
  const textNode = Array.prototype.find.call(link.childNodes, function(node) {
    return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
  });

  if (textNode) {
    textNode.textContent = label;
  } else {
    link.appendChild(document.createTextNode(label));
  }
}

function setImage(modal, sourceImage) {
  const modalImage = modal.querySelector(".team__img-col img");

  if (!modalImage || !sourceImage) return;

  copyImageAttribute(sourceImage, modalImage, "src");
  copyImageAttribute(sourceImage, modalImage, "srcset");
  copyImageAttribute(sourceImage, modalImage, "sizes");
  modalImage.alt = sourceImage.alt || getText(modal, ".team__content-name");
}

function copyImageAttribute(sourceImage, modalImage, attribute) {
  const value = sourceImage.getAttribute(attribute);

  if (value) {
    modalImage.setAttribute(attribute, value);
  } else {
    modalImage.removeAttribute(attribute);
  }
}
